import { User } from '$core/models/user';
// import { environment } from '$env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
// import * as Sentry from '@sentry/browser';
import { BehaviorSubject } from 'rxjs';
import { AuthenticationService } from './auth.service';
import { untilDestroyed } from '$core/operators/until-destroyed.operator';

@Injectable({ providedIn: 'root' })
export class SessionService implements OnDestroy {
  public session$ = new BehaviorSubject<User | null>(null);
  private _session: User;

  public get session() {
    return this._session;
  }

  public set session(v) {
    this._session = v ? new User(v) : undefined;
    this.session$.next(this.session);
  }

  constructor(
    private readonly authService: AuthenticationService,
    private readonly http: HttpClient
  ) {
    this.authService.isAuthorized$.subscribe((e) => {
      if (e) {
        this.getSession();
      } else {
        this.flushSession();
      }
    });

    // this.session$.subscribe(session => {
    //   if (environment.sentry) {
    //     Sentry.configureScope(scope => {
    //       scope.setUser(<any>{ ...session });
    //     });
    //   }
    // });
  }

  public getSession(): BehaviorSubject<User> {
    this.http
      .get<User>('/v1/users/self')
      .pipe(untilDestroyed(this))
      .subscribe((res) => {
        this.session = res;
      });

    return this.session$;
  }

  private flushSession(): void {
    this.session = null;
  }

  public ngOnDestroy(): void {}
}
